import Image from 'next/image';

import { IResolvedCardItem } from '@/src/utils/collections/cards.mapper';
import { CardContent } from '@/src/components/cards/CardContent/CardContent';

export const CardThreeColumnsItem = ({
  title,
  content,
  media,
}: IResolvedCardItem) => {
  return (
    <div
      className={
        'flex max-w-[250px] flex-col items-center gap-4 lg:mx-auto lg:max-w-[300px]'
      }
    >
      <div
        className={
          'flex size-15 items-center justify-center rounded-full bg-primary'
        }
      >
        {media.type === 'icon' && media.data && (
          <Image
            src={media.data.icon}
            alt={media.data.icon || ''}
            width={32}
            height={32}
          />
        )}
        {media.type === 'image' && media.data && (
          <Image
            placeholder={'blur'}
            blurDataURL={'/static/images/placeholder.webp'}
            src={media.data.image}
            alt={media.data.alt || ''}
            width={150}
            height={220}
          />
        )}
      </div>
      <div className={'space-y-1 text-center'}>
        <div className={'text-2xl font-semibold'}>{title}</div>
        <div className={'text-lg font-semibold leading-5 text-gray'}>
          <CardContent cardContent={content} />
        </div>
      </div>
    </div>
  );
};
